import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CoreService } from 'src/app/services/core/core.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { Constants } from 'src/app/constants/constants';

@Injectable({
  providedIn: 'root'
})
export class IvrCallsService {
  constructor(private coreService: CoreService) {};

  /* IVR Minimization */
  isIvrMinimized: BehaviorSubject<boolean> = new BehaviorSubject(false);

  private autoCallWidgetPhase = new BehaviorSubject<'dialing' | 'ongoing' | null>(null);
  autoCallWidgetPhase$ = this.autoCallWidgetPhase.asObservable();

  setAutoCallWidgetPhase(phase: 'dialing' | 'ongoing' | null): void {
    this.autoCallWidgetPhase.next(phase);
  }

  isCallOngoing(): boolean {
    let ongoing = false;
    this.isIvrMinimized.subscribe({
      next: (isIvrMinimized: boolean) => {
        ongoing = isIvrMinimized;
      }
    }).unsubscribe();
    return ongoing;
  }
  showOngoingCallWarning(toastService: ToastService): boolean {
    if (this.isCallOngoing()) {
      toastService.showToast(
        Constants.WARN,
        Constants.WARN_CAPS,
        "A call is ongoing. Please take necessary action before placing another call. Find the ongoing call at bottom right."
      );
      return true;
    }
    return false;
  }

  getIvrLogs(payload: any): Observable<any>{
    return this.coreService.callPostApi('member_connect/ivr_logs', payload, true);
  }

  initiateCall(payload: any): Observable<any>{
    return this.coreService.callPostApi('member_connect/initiate_call', payload, true, true);
  }

  /** Asks the backend to map this coach in Exotel and return the saved SIP username and secret. */
  ensureSipDevice(refresh = false): Observable<any>{
    return this.coreService.callPostApi('member_connect/ensure_sip_device', { refresh }, true);
  }

  saveInboundCall(payload: any): Observable<any>{
    return this.coreService.callPostApi('member_connect/save_inbound_call', payload, true, true);
  }

  updateCallDetails(payload: any): Observable<any>{
    return this.coreService.callPostApi('member_connect/update_call_details', payload, true);
  }

  saveCallDisposition(payload: any): Observable<any>{
    return this.coreService.callPostApi('member_connect/save_call_disposition', payload, true);
  }

  getCallAttempts(payload: any): Observable<any>{
    return this.coreService.callPostApi('member_connect/get_call_attempts', payload, true);
  }

  getFamilyCallMembers(payload: any): Observable<any>{
    return this.coreService.callPostApi('member_connect/family_call_members', payload, true);
  }

  updateCallDisposition(payload: any): Observable<any>{
    return this.coreService.callPostApi('member_connect/update_call_disposition', payload, true);
  }
  
  getCoachRecordingStatus(): Observable<any>{
    return this.coreService.callPostApi('member_connect/coach_recording_status', null, true);
  }

  checkTaskRecordingStatus(callLogId: number): Observable<any>{
    return this.coreService.callPostApi('member_connect/check_task_recording_status', { call_log_id: callLogId }, true);
  }

  getExophoneCallStatus(callLogId: number | string, callRecordId?: number | string): Observable<any>{
    const payload: Record<string, number | string> = { call_log_id: callLogId };
    if (callRecordId) {
      payload['call_record_id'] = callRecordId;
    }
    return this.coreService.callPostApi('member_connect/check_task_recording_status', payload, true, true);
  }
}
